export enum RentalUnitType {
	APPARTMENT = 'APPARTMENT',
	BOAT = 'BOAT',
	BUNGALOW = 'BUNGALOW',
	CAMPSITE = 'CAMPSITE',
	DORMITORY = 'DORMITORY',
	HOUSE = 'HOUSE',
	LOG_CABIN = 'LOG_CABIN',
	MOBILE_HOME = 'MOBILE_HOME',
	OTHER = 'OTHER',
	ROOM = 'ROOM',
	STUDIO = 'STUDIO',
	TENT = 'TENT',
	UNIT = 'UNIT',
}

export const RENTAL_UNIT_TYPES = [
	RentalUnitType.APPARTMENT,
	RentalUnitType.STUDIO,
	RentalUnitType.HOUSE,
	RentalUnitType.ROOM,
	RentalUnitType.DORMITORY,
	RentalUnitType.LOG_CABIN,
	RentalUnitType.BOAT,
	RentalUnitType.BUNGALOW,
	RentalUnitType.CAMPSITE,
	RentalUnitType.MOBILE_HOME,
	RentalUnitType.TENT,
	RentalUnitType.UNIT,
	RentalUnitType.OTHER,
];
